import React, { useState, useEffect } from 'react'
import { startLoading, doneLoading } from '../../../utils/loading'
import { Table, Icon, Checkbox, SelectPicker } from 'rsuite'
import { downloadInstallmentIncomeDetail } from '../../../redux/actions/projectBasedItems'
import { previewFile } from '../../../utils/fileUtil'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function ModalDurableArticles({
  modalSchema,
  isEdit,
  setIsLoading = () => {},
  selectedList = [],
  setSelectedList = () => {},
}) {
  const { Column, HeaderCell, Cell } = Table
  const [datas, setDatas] = useState(modalSchema?.values || [])

  useEffect(() => {
    setDatas(modalSchema.values)
  }, [modalSchema.values])

  const handlePreviewFile = async (path) => {
    startLoading()
    setIsLoading(true)

    try {
      const file = await downloadInstallmentIncomeDetail(path)
      console.log('path ', file)

      if (file) {
        var r = path.split('/')

        previewFile(file, r[r.length - 1])
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        // height={500}
        data={datas}
        style={{ marginTop: 10 }}
        headerHeight={65}
      >
        <Column width={90} align="center" fixed="left">
          {isEdit ? (
            <HeaderCell>
              <Checkbox
                style={{ marginTop: '-7px', marginLeft: -10 }}
                checked={selectedList?.length == datas?.length}
                onChange={(_, checked) => {
                  if (checked) {
                    var arr = []

                    datas.map((e) => {
                      arr.push({ id: e.id, assetType: e.assetTypeCode })
                    })

                    setSelectedList(arr)
                  } else {
                    setSelectedList([])
                  }
                }}
              >
                {' '}
                <b>ลำดับ</b>
              </Checkbox>
            </HeaderCell>
          ) : (
            <HeaderCell>ลำดับ</HeaderCell>
          )}

          <Cell>
            {(rowData, index) => {
              return (
                <>
                  {isEdit ? (
                    <Checkbox
                      style={{ marginTop: '-7px', marginLeft: -10 }}
                      checked={selectedList.filter((e) => e.id == rowData.id)?.length > 0}
                      onChange={(value, checked) => {
                        if (checked) {
                          var arr = [...selectedList]
                          arr.push({ id: rowData.id, assetType: rowData.assetTypeCode })
                          setSelectedList(arr)
                        } else {
                          var arr = selectedList.filter((e) => e.id !== rowData.id)
                          setSelectedList(arr)
                        }
                      }}
                    >
                      {index + 1}
                    </Checkbox>
                  ) : (
                    index + 1
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={180}>
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>
        <Column width={200} minWidth={200} flexGrow={1}>
          <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>
        <Column width={100}>
          <HeaderCell>ราคา/หน่วย</HeaderCell>
          <Cell align="right">
            {(rowData) => {
              return <span>{budgetFormat(rowData.unitPrice || 0)}</span>
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รุ่น</HeaderCell>
          <Cell dataKey="assetModel" />
        </Column>
        <Column width={150}>
          <HeaderCell>ยี่ห้อ</HeaderCell>
          <Cell dataKey="assetBrand" />
        </Column>
        <Column width={200}>
          <HeaderCell>หมวดครุภัณฑ์</HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <>
                  {isEdit ? (
                    <SelectPicker
                      searchable={false}
                      data={modalSchema.assetType.options}
                      value={rowData.assetTypeCode}
                      block
                      placeholder="เลือก"
                      onChange={(value) => {
                        //props.onChange(value)
                        var values = [...datas]

                        values[index].assetTypeCode = value
                        setDatas(values)

                        var i = selectedList.findIndex((e) => e.id == rowData.id)

                        if (i >= 0) {
                          selectedList[i].assetType = value

                          setSelectedList(selectedList)
                        }
                      }}
                    />
                  ) : (
                    <>
                      {
                        modalSchema.assetType.options.find((e) => e.value == rowData.assetTypeCode)
                          ?.label
                      }
                    </>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={120}>
          <HeaderCell>เลขที่ใบเสร็จ</HeaderCell>
          <Cell dataKey="assetBillNo" />
        </Column>
        <Column width={120}>
          <HeaderCell>วันที่ในใบเสร็จ</HeaderCell>
          <Cell dataKey="assetBillDate" />
        </Column>
        <Column width={100} align="center">
          <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
          {/* <Cell dataKey="uploadPic" /> */}
          <Cell>
            {(rowData) => {
              return (
                <>
                  {rowData.assetPicturePathFile && (
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        handlePreviewFile(rowData.assetPicturePathFile)
                      }}
                    >
                      <Icon icon="image" style={{ marginRight: 5 }} />
                      คลิกดูรูป
                    </a>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={120} align="center">
          <HeaderCell>ใบเสร็จครุภัณฑ์</HeaderCell>
          {/* <Cell dataKey="uploadReceipt" /> */}
          <Cell>
            {(rowData) => {
              return (
                <>
                  {rowData.assetBillPathFile && (
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        handlePreviewFile(rowData.assetBillPathFile)
                      }}
                    >
                      <Icon icon="image" style={{ marginRight: 5 }} />
                      คลิกดูรูป
                    </a>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={120}>
          <HeaderCell>วันที่ตรวจรับพัสดุ</HeaderCell>
          <Cell dataKey="assetReceiveDate" />
        </Column>
        <Column width={120} align="center">
          <HeaderCell>เอกสารตรวจรับ</HeaderCell>
          {/* <Cell dataKey="uploadReceipt" /> */}
          <Cell>
            {(rowData) => {
              return (
                <>
                  {rowData.assetReceiveFile && (
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        handlePreviewFile(rowData.assetReceiveFile)
                      }}
                    >
                      <Icon icon="file-text" style={{ marginRight: 5 }} />
                      คลิกดูเอกสารตรวจรับ
                    </a>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </>
  )
}
